export const paths = {
  user: "/user",
  agencies: "/agency/list",
  historyLogs: "/history-logs",
  historyLogsFilters: "/history-logs/filters",
  reportHealth: "/report/logs",
  corporateListWithAgencies: "/corporate/list-with-agencies",
  notifications: "/notification/list",
  updateFcmToken: "/account/update-fcm-token",
  markAsReadNotification: (id) => `/notification/${id}/mark-as-read`,
  locales: "/locale/index",
  activeLocales: "active-locales",
  localesCreate: "/locale/create",
  availableLocales: "/locale/available-locales",
  localesUpdate: (id) => `/locale/update/${id}`,
  translationKeys: "/translation-key/index",
  keyTypes: "/key-type/index",
  updateOrCreateTranslationKey: "/translation-key/update-or-create",
  translationKeyDetails: (id) => `/translation-key/details/${id}`,
  createTranslationKey: "/translation-key/create",
  updateTranslationKey: (id) => `/translation-key/update/${id}`,
  createTranslation: "/translation-key/update-or-create",
  updateTranslation: (id) => `/translation/update/${id}`,
  languageJson: "/translations",
  setUserLanguage: "/account/set-locale",
  transferFacilities: (agency_id)=> `facility/simple-list-by-agency/${agency_id}`,
  translationKeysCsvFile: "/export-to-csv",
  importTranslationKeysCsvFile: "/import-from-csv",
  inspectionResultHistory: (resultId) => `/inspection/result/${resultId}/history`,
  notificationPreferences: "/account/notification-preferences",
  updateNotificationPreferences: "/account/update-notification-preferences",
};

export default paths;